import { useCallback } from 'react';
import { authApi } from '../utils/api';
import { useAuthStore } from '../stores/authStore';

/**
 * 配额刷新 hook
 * 在功能请求成功后调用 refreshQuota() 从服务端获取最新配额并更新本地状态
 */
export function useQuotaUpdate() {
  const updateUser = useAuthStore((state) => state.updateUser);

  const refreshQuota = useCallback(async () => {
    try {
      const res = await authApi.getProfile();
      const { daily_quota, used_today, remaining } = res.data;
      updateUser({ daily_quota, used_today, remaining });
    } catch {
      // 静默失败，不影响主流程
    }
  }, [updateUser]);

  return { refreshQuota };
}
